import { useSyncExternalStore } from 'react'

export type MembershipSidePanelOverview = {
  tier: string
  memberSince: string
  billingFrequency: string
  nextPaymentDate: string
}

let overview: MembershipSidePanelOverview | null = null
const listeners = new Set<() => void>()

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = (): MembershipSidePanelOverview | null => overview

export const setMembershipSidePanelOverview = (
  next: MembershipSidePanelOverview | null,
): void => {
  overview = next
  listeners.forEach((listener) => listener())
}

export const useMembershipSidePanelOverview =
  (): MembershipSidePanelOverview | null =>
    useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
